import React, { ElementType } from 'react'
import clsx from 'clsx'
import { twMerge } from 'tailwind-merge'
import Typography from '@mui/material/Typography'
import ButtonBase from '@mui/material/ButtonBase'
import styles from './Stepper.module.scss'

export type StepperItemType = {
  title: string
  onClick?: () => void
}
type StepperProps = {
  activeIndex?: number
  className?: string
  classes?: {
    root?: string
    step?: string
    stepActive?: string
  }
  data: StepperItemType[]
  singleView?: boolean
}

const StepperItemComponent: React.FC<{
  item: StepperItemType
  index: number
  component?: ElementType
}> = ({ component: Component = 'div', item, index }) => (
  <>
    <Component className={styles.StepperNumber}>
      <Typography variant="overline" component={Component}>
        {index + 1}
      </Typography>
    </Component>

    <Component className={styles.StepperContent}>
      <Typography variant="overline" component={Component}>
        {item.title}
      </Typography>
    </Component>
  </>
)

const Stepper: React.FC<StepperProps> = props => {
  const { activeIndex, className, classes, data, singleView } = props

  return (
    <div
      className={twMerge(
        'flex select-none',
        singleView && styles.StepperSingleView,
        className,
        classes?.root
      )}
    >
      {data.map((item, index) => {
        return (
          <div
            key={item.title}
            className={clsx(
              styles.StepperItem,
              classes?.step,
              activeIndex === index ? styles.StepperItemActive : undefined,
              activeIndex === index ? classes?.stepActive : undefined
            )}
          >
            {item.onClick ? (
              <ButtonBase onClick={item.onClick}>
                <StepperItemComponent item={item} index={index} component="span" />
              </ButtonBase>
            ) : (
              <StepperItemComponent item={item} index={index} />
            )}
          </div>
        )
      })}
    </div>
  )
}

export default Stepper
